"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuOverlay = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
function MenuOverlay({ className, isNavigationOverlay = false, open = false, }) {
    const [triggerOpacity, setTriggerOpacity] = (0, react_1.useState)(open);
    const [triggerDisplay, setTriggerDisplay] = (0, react_1.useState)(open);
    (0, react_1.useEffect)(() => {
        // // Steps for opening overlay
        // Step 1: Open overlay
        // Step 2: Turn 'hidden' to 'block'
        // Step 3: Turn 'opacity-0' to 'opacity-1'
        // // Steps for closing overlay
        // Step 1: Close overlay
        // Step 2: Turn 'opacity-1' to 'opacity-0'
        // Step 3: Turn 'block' to 'hidden'
        if (open) {
            setTriggerDisplay(open);
            // setTimeout used to offset trigger for changing opacity (opacity duration is instant instead of 100ms without)
            setTimeout(() => setTriggerOpacity(open), 0);
        }
        else {
            setTriggerOpacity(open);
            // setTimeout used to offset trigger for changing display (display hides instantly resulting in no opacity transition without)
            setTimeout(() => setTriggerDisplay(open), 100);
        }
    }, [open]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('fixed top-0 left-0 w-full h-full bg-gray-overlay duration-100 transition-opacity pointer-events-none', {
            'opacity-0': !triggerOpacity,
            'opacity-1': triggerOpacity,
        }, {
            'hidden ': !triggerDisplay,
            'block ': triggerDisplay,
        }, {
            'z-20': !isNavigationOverlay,
            'z-1': isNavigationOverlay,
        }, className) }));
}
exports.MenuOverlay = MenuOverlay;
